import { useSelector } from 'react-redux';
import { RootState } from 'redux/types';

const getAuthorizedWells = (store: RootState) => store.wells.authorizedWells;
export const useSelectAuthorizedWells = () => useSelector(getAuthorizedWells);

const getAuthorizedWellbores = (store: RootState) => store.wells.authorizedWellbores;
export const useSelectAuthorizedWellbores = () => useSelector(getAuthorizedWellbores);

const getCurrentWellbore = (store: RootState) => store.wells.currentWellbore;
export const useSelectCurrentWellbore = () => useSelector(getCurrentWellbore);

const getCurrentWell = (store: RootState) => store.wells.currentWell;
export const useSelectCurrentWell = () => useSelector(getCurrentWell);

const getCurrentTimezone = (store: RootState) => store.wells.currentTimezone;
export const useSelectCurrentTimezone = () => useSelector(getCurrentTimezone);
